import React from "react";
import * as S from "../style";

export const getInsuranceColumns = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderActions: (record: any) => React.ReactNode,
  status: "A" | "C"
) => [
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: () => (
        <S.InsuranceStatusLetter
          className={status === "C" ? "canceled" : "active"}
        >
          {status}
        </S.InsuranceStatusLetter>
      ),
    },
    {
      title: "Código",
      dataIndex: "codigo",
      key: "codigo",
    },
    {
      title: "Descrição",
      dataIndex: "descricao",
      key: "descricao",
    },
    {
      title: "Valor",
      dataIndex: "valor",
      key: "valor",
      render: (valor: number) => `R$ ${valor.toFixed(2)}`,
    },
    {
      title: "Ações",
      key: "acoes",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      render: (_: any, record: any) => renderActions(record),
      width: 80,
    },
  ];
